import { render, staticRenderFns } from "./HeaderCouponList.vue?vue&type=template&id=852bb2a8&scoped=true&"
import script from "./HeaderCouponList.vue?vue&type=script&lang=js&"
export * from "./HeaderCouponList.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCouponList.vue?vue&type=style&index=0&id=852bb2a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852bb2a8",
  null
  
)

export default component.exports